<script setup lang="ts">
import type { SwitchRootEmits, SwitchRootProps } from 'radix-vue'
import type { HTMLAttributes } from 'vue'
import {
  SwitchRoot,
  SwitchThumb,
  useForwardPropsEmits,
} from 'radix-vue'
import { computed } from 'vue'
import type { SwitchVariants } from '.'
import { switchThumbVariants, switchVariants } from '.'
import { cn } from '~/helpers'

const props = defineProps<SwitchRootProps & {
  class?: HTMLAttributes['class']
  size?: SwitchVariants['size']
}>()

const emits = defineEmits<SwitchRootEmits>()

const delegatedProps = computed(() => {
  const { class: _, size: __, ...delegated } = props
  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <SwitchRoot
    v-bind="forwarded"
    :class="cn('data-[state=checked]:bg-softBlack data-[state=unchecked]:bg-input', switchVariants({ size }), props.class)"
  >
    <SwitchThumb
      :class="cn(switchThumbVariants({ size }))"
    >
      <slot name="thumb" />
    </SwitchThumb>
  </SwitchRoot>
</template>

<style>
.item-checked_translate-x-4[data-state=checked] {
  transform: translateX(1rem);
  transition: transform 0.2s ease-in-out;
}

.item-checked_translate-x-5[data-state=checked] {
  transform: translateX(1.25rem);
  transition: transform 0.2s ease-in-out;
}

.item-checked_translate-x-7[data-state=checked] {
  transform: translateX(1.75rem);
  transition: transform 0.2s ease-in-out;
}
</style>
